<h2 mat-dialog-title>Anmelden</h2>
<mat-dialog-content [formGroup]="form">
    <mat-form-field style="width: 100%;">
        <input type="text" matInput placeholder="Benutzername/Email-Adresse" formControlName="userName" required cdkFocusInitial>
        <mat-icon matSuffix style="color: grey;">mail</mat-icon>
        <mat-error *ngIf="hasError('userName', 'required')">
            Benutzername oder Email-Adresse ist erforderlich
        </mat-error>    
    </mat-form-field>
    <mat-form-field class="mt-2" style="width: 100%;">
        <input type="password" matInput placeholder="Passwort" formControlName="userPwd" required>
        <mat-icon matSuffix style="color: grey;">lock</mat-icon>
        <mat-error *ngIf="hasError('userPwd', 'required')">
            Passwort ist erforderlich
        </mat-error>    
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Abbrechen</button>
    <button mat-button (click)="onLogin()">Anmelden</button>
</mat-dialog-actions>